<template>
  <div class="page-default-layout" style="overflow: auto">
    <keep-alive :max="200">
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
export default {
  name: 'promoteLayout',
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.page-default-layout {
  // header 64px; nav 50px
  height: calc(100vh - 64px - 50px);
  background: #f0f2f5;
}
</style>
